export default {
  getSysUserRole: {
    url: '/sys/set/role/getSysUserRole',
    method: 'post'
  },
  getUserRoleCode: {
    url: '/sys/set/role/getUserRoleCode'
  },
  addRegister: {
    url: '/sys/set/role/addRegister',
    method: 'post'
  },
  editSysUserRole: {
    url: '/sys/set/role/editSysUserRole',
    method: 'post'
  },
  delSysUserRole: {
    url: '/sys/set/role/delSysUserRole',
    method: 'post'
  },
  setRoleTransfer: {
    url: '/sys/set/role/transfer',
    method: 'post'
  }
};
